import React, { useEffect, useRef } from "react";

const RingtonePlayer = ({ isPlaying, ringtoneUrl }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.play().catch((error) => {
          console.error("Error playing ringtone:", error);
        });
      } else {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    }
  }, [isPlaying]);

  return <audio ref={audioRef} src={ringtoneUrl} loop preload="auto" />;
};

export default RingtonePlayer;
